import { Form } from "antd";
import { useParams } from "react-router";

import type { FieldMethod, FormFieldFactoryProps } from "../../types/types";
import { CreateTablePlaceholderComponent } from "../CreateTablePlaceholderComponent";
import { ContractTerminalsTable } from "./ContractTerminalsTable";

const WATCHED_FIELDS = ["siteId", "allIPT", "allOPT", "allUnattended", "allEcommerce", "allEvcharger"] as const;

export const ContractTerminalsTableField: FieldMethod = ({ field, readOnly }: FormFieldFactoryProps) => {
    const { id } = useParams();

    return id ? (
        <Form.Item noStyle shouldUpdate={(prevValues, currentValues) => WATCHED_FIELDS.some((f) => prevValues[f] !== currentValues[f])}>
            {({ getFieldValue }) => {
                const selectedTerminalTypes = {
                    allIPT: getFieldValue("allIPT"),
                    allOPT: getFieldValue("allOPT"),
                    allUnattended: getFieldValue("allUnattended"),
                    allEcommerce: getFieldValue("allEcommerce"),
                    allEvcharger: getFieldValue("allEvcharger"),
                };

                return (
                    <Form.Item key={`${field.name}FormItem`} name={field.name}>
                        <ContractTerminalsTable
                            key={field.name}
                            readOnly={readOnly}
                            siteId={getFieldValue("siteId")}
                            selectedTerminalTypes={selectedTerminalTypes}
                        />
                    </Form.Item>
                );
            }}
        </Form.Item>
    ) : (
        <CreateTablePlaceholderComponent />
    );
};
